import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { INotification } from '../../models/notification.model';

@Injectable()
export class NotificationService {
  private subject = new Subject<INotification>();
  private idx = 0;
  private handleNotifications = true;

  constructor() {}

  getObservable(): Observable<INotification> {
    return this.subject.asObservable();
  }

  displayMessage(message: string, timeout = 5000, styles = ''): Subject<any> {
    const clickSubject = new Subject<boolean>();

    if (!this.handleNotifications) {
      return clickSubject;
    }

    this.subject.next({
      id: this.idx++,
      data: {
        message,
        styles,
      },
      timeout,
      key: 'message',
      click: clickSubject,
    });

    return clickSubject;
  }

  setHandleNotifications(handle: boolean): void {
    this.handleNotifications = handle;
  }
}
